var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDude = function SvgIconDude(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M38 19v-5H27v5M8.858 19.03l-.44.97A17.6 17.6 0 0 0 7 26.944C7 36.916 15.283 45 25.5 45S44 36.916 44 26.944c0-2.46-.504-4.806-1.418-6.944l-.429-.97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M27 5V3h-4v2M43 19v-7a7 7 0 0 0-7-7H17a7 7 0 0 0-7 7v2l-8 .5V19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M35 26a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM20 26a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M25 38.017c3.424 0 6.483-1.564 8.5-4.017"
  })));
};
export default SvgIconDude;